/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import store from 'features/store';
import { DoorView } from 'shared/door-view/DoorView';
import { connect } from 'react-redux';
import SalesService from 'shared/services/SalesService';
import validators from 'shared/validators';
import { convertToMaintainData, estateList, getMaintainData } from 'shared/settings/stateMaintain';
import Helmet from 'react-helmet';

import { CityAndStateService } from 'shared/services';
import './EstateSaleList.scss';
import { bannerImage } from 'shared/utils/utils';
import { ADSENSE } from 'shared/settings/config';
import { Adsense } from 'shared/utils/Adsense';
/**


@Author Karthik

@param

@return Estate sale list html

**/

class EstateSaleList extends Component {
    constructor(props) {
        super(props);
        this.scrollRef = createRef();
        this.state = {
            salesList: [],
            stateList: [],
            innerWidth: window.innerWidth,
            nextList: null,
            pageLoading: true,
            loaderForMore: false,
            estateSaleForm: {
                zipcode: { value: '', error: '', validators: [validators.equalToLength(5)] },
                miles: { value: '25', error: '', validators: [validators.required()] },
                state: { value: '', error: '', validators: [] },
            },
            errorMessage: '',
            formValid: false,
            refreshScreen: false,
            scrollTo: 0,
            isVisible: false,
            pageClientWidth: 16,
        }
    }

    componentDidMount() {
        this.formValueSet();
        this.getPreviousValues();
        store.dispatch({ type: 'FOOTER', payload: false });
        window.addEventListener('resize', this.setHeight);
        this.getSaleList()
    }

    getSaleList(){
        CityAndStateService.getStateList().then(
            stateList => {
                this.setState({
                    stateList: stateList.data.data,
                });
            }
        ).catch((error) => {
        
        });
    }

    componentDidUpdate(prevProps) {
        window.addEventListener('resize', this.setHeight);
        store.dispatch({ type: 'FOOTER', payload: false });
        if (JSON.stringify(prevProps.match.params) !== JSON.stringify(this.props.match.params)) {
            this.formValueSet();
        }
    }

    getPreviousValues = () => {
        const previous = getMaintainData(estateList);
        const check = this.props.history.action === "POP" && this.props.previousPath.component === "EstateSaleByCategory";
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "EstateSale" } });
        if (previous && check) {
            delete previous.estateSaleForm
            this.setState({
                ...previous,
                pageLoading: false,
            }, () => {
                this.scrollToPrevious();
            });
        }
    }

    scrollToPrevious = () => {
        setTimeout(() => {
            this.scrollRef.current.scrollTo({ top: this.state.scrollTo, left: 0 });
        }, 100);
    }

    navigate = (sale) => {
        convertToMaintainData(estateList, {
            ...this.state
        });
        this.props.history.push({pathname: `/estate-sale/${sale.id}`, state: {saleTitle: sale.title}});
    }

    /* Called when resize the screen */
    setHeight = () => {
        this.setState({
            innerWidth: window.innerWidth,
            pageClientWidth: this.scrollRef?.current?.clientWidth
        });
    }

    getSalesList = (append = false) => {
        this.setState({
            pageLoading: !append
        }, () => {
            const estateForm = this.state.estateSaleForm;
            const endingSoonData = {
                "sort": [{ "field": "endtimeutc", "direction": "asc" }],
                "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc"],
                "filter": [{ "field": "itemcount", "value": 1, "op": ">=", "join": "AND" }, { "field": "status", "value": "Started", "op": "=", "join": "AND" }],
                "page": this.state.nextList && append ? { "size": 6, next: this.state.nextList } : { 'size': 6 }
            }

            if (estateForm.zipcode.value) {
                endingSoonData.filter.push({ "field": "zipcode", "value": estateForm.zipcode.value, "op": "=", "join": "AND" });
            }
            if (estateForm.miles.value) {
                endingSoonData.filter.push({ "field": "miles", "value": estateForm.miles.value, "op": "=", "join": "AND" });
            }
            if (estateForm.state.value) {
                endingSoonData.filter.push({ "field": "state", "value": estateForm.state.value, "op": "=", "join": "AND" });
            }

            SalesService.getSalesList(endingSoonData).then(
                endingSoon => {
                    let temp = [];
                    if (append) {
                        temp = temp.concat(this.state.salesList, endingSoon.data.data);
                    } else {
                        temp = endingSoon.data.data;
                    }

                    if ( temp.length > 0 ) {
                        const imageListData = { "filter": [{ "field": "saleid", "value": [temp.map(elem => { return elem.id; })], "op": "IN", "join": "AND" }] };
                        SalesService.getSaleImagesList(imageListData).then(
                            saleImageList => {
                                temp.forEach((elem) => {
                                    let imageData = saleImageList.data.data.find((image) => {  return image.saleid == elem.id; })
                                    if (typeof imageData != "undefined") {
                                        let imageUrlData = imageData.saleimageurl || imageData.locationimageurl;
                                        if ( typeof imageUrlData === 'string' ) {
                                            elem.saleimageurl = imageUrlData.split(',').find(img => { return img.includes('profile#*#'); })?.split("#*#")[1];
                                        }
                                    }
                                })
                                this.setState({
                                    salesList: temp,
                                    nextList: endingSoon.data.page && endingSoon.data.page.keyset && endingSoon.data.page.keyset.next ? endingSoon.data.page.keyset.next : null,
                                    pageLoading: false,
                                    loaderForMore: false
                                }); 
                            }        
                        ).catch((error) => {
                            // TODO: Error message handle
                        });
                    } else {
                        this.setState({
                            salesList: temp,
                            nextList: null,
                            pageLoading: false,
                            loaderForMore: false
                        }); 
                    }
                }
            ).catch((error) => {
                this.setState({
                    pageLoading: false,
                    loaderForMore: false
                });
                // TODO: Error message handle
            });
        });
    }

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName) => {
        let controlError = '';

        if (event.target.name === 'zipcode') {
            if (isNaN(Number(event.target.value)))
                event.target.value = '';
        }

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            },
            errorMessage: '',
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ formValid: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }
    
                if (event.target.name === 'state') {
                    this.setState({
                        [formName]: {
                            ...this.state[formName],
                            zipcode: { value: '', error: '', validators: [validators.equalToLength(5)] }, 
                        },
                    });
                }
    
                if (event.target.name === 'zipcode') {
                    this.setState({
                        [formName]: {
                            ...this.state[formName],
                            state: { value: '', error: '', validators: [] },
                        },
                    });
                }
            }
        );
    };

    getMoreList = () => {
        this.setState({
            loaderForMore: true
        }, () => {
            this.getSalesList(true);
        })
    }

    formValueSet = () => {
        const value = this.props.match.params;
        if ('filter' in value) {
            const filter = atob(value.filter);
            const formValue = JSON.parse(filter);
            this.setState({
                ...this.state,
                estateSaleForm: {
                    ...this.state.estateSaleForm,
                    zipcode: {
                        ...this.state.estateSaleForm.zipcode,
                        value: formValue.zipcode
                    },
                    state: {
                        ...this.state.estateSaleForm.state,
                        value: formValue.state
                    },
                    miles: {
                        ...this.state.estateSaleForm.miles,
                        value: formValue.miles ? formValue.miles : '25'
                    }
                }
            }, () => {
                this.getSalesList();
            });
        } else {
            this.setState({
                ...this.state,
                estateSaleForm: {
                    ...this.state.estateSaleForm,
                    zipcode: {
                        ...this.state.estateSaleForm.zipcode,
                        value: ""
                    },
                    state: {
                        ...this.state.estateSaleForm.state,
                        value: ""
                    },
                    miles: {
                        ...this.state.estateSaleForm.miles,
                        value: '25'
                    }
                }
            }, () => {
                this.getSalesList();
            })
        }
    }
    clearAll = () => {
       this.setState({
        ...this.state,
        estateSaleForm: {
            ...this.state.estateSaleForm,
            zipcode: {
                ...this.state.estateSaleForm.zipcode,
                value: ""
            },
            state: {
                ...this.state.estateSaleForm.state,
                value: ""
            },
            miles: {
                ...this.state.estateSaleForm.miles,
                value: '25'
            }
        }
       },()=>{
        this.props.history.push(`/estate-sale/list`);
       })
    }

    estateSaleFind = (event) => {
        event.preventDefault();
        const estateForm = this.state.estateSaleForm;
        // if (!estateForm.zipcode.value) {
        //     this.setState({
        //         errorMessage: 'Please enter value'
        //     });
        // } else {
            const data = {
                zipcode: estateForm.zipcode.value,
                miles: estateForm.miles.value,
                state: estateForm.state.value
            };
            const final = btoa(JSON.stringify(data));
            this.props.history.push(`/estate-sale/list/${final}`);
        // }

    }

    removeSale = (index) => {
        this.setState({
            refreshScreen: true
        }, () => {
            const temp = this.state.salesList;
            temp.splice(index, 1);
            this.setState({
                salesList: temp
            });
            setInterval(() => {
                this.setState({
                    refreshScreen: false
                });
            }, 500)
        });
    }

    /* Called when scroll content */
    handleScroll = (event = null) => {
        /* Storing scroll-top for handle previous state */
        this.setState({
            scrollTo: event ? event.target.scrollTop : 0,
            pageClientWidth: this.scrollRef?.current?.clientWidth,
            isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
        });
    }

    scrollToTop = () => {
        this.scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        return (
            <div className="estate-sale-list" onScroll={event => this.handleScroll(event)} ref={this.scrollRef}>
                <Helmet>
                    <title>CTBids | Online Estate Sales</title>
                    <meta name='description' content="Find antiques, art from the category list in the description" />
                    <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                    <link rel="canonical" href={`https://ctbids.com/estate-sale/list`} />
                </Helmet>
                {
                    this.state.isVisible ?
                        <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={this.scrollToTop}>
                            <i className="fas fa-arrow-up"></i>
                        </div> : null
                }
                 <div className="header-content " style={{ textAlign:'center'}}>
                    <div className='estate-haading'> Discover What’s Behind The Doors of Our Estates</div>
                </div>                 
                <div className="content-body d-flex align-items-center justify-content-center">
                    <div className="large-screen-width">
                    <div className="header-content">
                    <div className="justify-content-center">
                        <div className="">
                            <div className="d-lg-flex align-items-md-center justify-content-between">
                                <div className="left d-flex align-items-center">
                                    <div className="h5 header">
                                        <span className="border-set"></span>
                                        Find Your Perfect Estate Sales
                                    </div>
                                </div>
                                <div className="right d-md-flex align-items-start">
                                    <Form className="form d-md-flex" onSubmit={this.estateSaleFind}>
                                        {/* <Form.Group controlId="distance">
                                            <Form.Control as="select" name="state" aria-label="select location" value={this.state.estateSaleForm.state.value} onChange={(event) => this.onInputValidation(event, "estateSaleForm")}>
                                                <option value="All">State</option>
                                                {
                                                    this.state.stateList
                                                    .sort((a, b) => a.state.localeCompare(b.state))
                                                    .map((state, index) => <option key={`state_${index}`} value={state.state}>{state.state}</option>)
                                                }

                                            </Form.Control>
                                        </Form.Group>
                                        <p style={{marginTop: '3%',textAlign: 'center'}}>OR</p>
                                         */}
                                        <Form.Group controlId="zipcode">
                                            <Form.Control type="text" placeholder="Enter Zip code" aria-label='Enter zipcode' name="zipcode" value={this.state.estateSaleForm.zipcode.value} onChange={(event) => this.onInputValidation(event, "estateSaleForm")} />
                                            {
                                                this.state.estateSaleForm.zipcode.value && this.state.estateSaleForm.zipcode.error ? <small className="text-danger">{this.state.estateSaleForm.zipcode.error}</small> : null
                                            }
                                            {
                                                this.state.errorMessage ? <small className="text-danger">{this.state.errorMessage}</small> : null
                                            }
                                        </Form.Group>
                                        <Form.Group controlId="distance">
                                            <Form.Control as="select" placeholder="Select distance"  aria-label='select distance' name="miles" value={this.state.estateSaleForm.miles.value} onChange={(event) => this.onInputValidation(event, "estateSaleForm")}>
                                                <option value="5">5 Miles</option>
                                                <option value="10">10 Miles</option>
                                                <option value="25">25 Miles</option>
                                                <option value="50">50 Miles</option>
                                                <option value="100">100 Miles</option>
                                                <option value="250">250 Miles</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Form>
                                    <Button style={{backgroundColor: "#a50050", marginRight: '2px'}} className="find-button clickable" aria-label='Find' onClick={this.estateSaleFind}>Find</Button>
                                    {/* <Button className="find-button clickable" aria-label='clear' onClick={this.clearAll}>Clear All</Button> */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                        {
                            this.state.pageLoading || this.state.refreshScreen ? <div className="loader d-flex align-items-center justify-content-center">
                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                            </div> :
                                <div className="d-flex align-items-center justify-content-center">
                                    <Row xs={1} sm={1} md={1} lg={this.state.salesList.length < 3 ? this.state.salesList.length : this.state.innerWidth < 1225 ? 2 : this.state.innerWidth >= 1707 ? 3 : 3} className='sale-card-wrapper'>
                                        {
                                            this.state.salesList.map((items, index) => {
                                                return (
                                                    <>
                                                        <Col key={`items_${index}_${items.id}`}>
                                                            <DoorView sale={items} config={{ index: index }} navigate={this.navigate} getNewSaleList={this.getNewSaleList} removeSale={() => this.removeSale(index)}></DoorView>
                                                        </Col>

                                                        {
                                                            ADSENSE.ENABLE && index !== 0 && (index + 1) % 6 === 0 ? <Adsense googleAdCenter slotId={ADSENSE.ESTATE_SALE.slotId} /> : ''
                                                        }
                                                    </>         
                                                )  
                                            })
                                        }
                                    </Row>
                                </div>
                        }
                        {
                            this.state.salesList.length === 0 && !this.state.pageLoading ?
                                <div className="no-data-found mt-3 h-20 d-flex flex-column align-items-center justify-content-center">
                                    <div className="text-center no-data-search-icon">
                                        <i className="fas fa-search fa-3x"></i>
                                    </div>
                                    <div className="text-center h4 text-bold">
                                        No results found
                                    </div>
                                    <div className="text-center text-muted h5">
                                        We couldn't find what you're looking for.
                                    </div>
                                </div> : null
                        }
                        {
                            this.state.nextList && !this.state.pageLoading?
                                <div className="d-flex justify-content-center">
                                    <div className={`browse-all clickable ${this.state.loaderForMore || !this.state.nextList ? 'custom-disable' : '' }`} onClick={this.getMoreList}>
                                        More {this.state.loaderForMore ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                    </div>
                                </div> : null
                        }
                    </div>
                </div>
                {!this.props.user.membershipCompleted ?
                    <div className='w-100' style={{ justifyContent: 'center', alignItems: ' center', display: 'flex', }}>
                        {bannerImage(this.props, 'Premier-BannerAd-Estate-Unlock3')}
                    </div> : ''}
            </div>
        );
    }
}

export default connect(state => state)(EstateSaleList);